import type { ExtractedFact } from '@karehero/models';

import {
  FIRST_NAME_FACT,
  FULL_NAME_FACT,
  LAST_NAME_FACT,
  PERSONAL_DETAILS_TOPIC,
  findFact,
} from './extractedFacts';
import type { NameParts } from './splitFullName';

const nameFact = (
  facts: readonly ExtractedFact[],
  topicSlug: string,
  factName: string,
): string | undefined => {
  const fact = findFact(facts, topicSlug, factName);
  return typeof fact?.factValue === 'string'
    ? fact.factValue.trim() || undefined
    : undefined;
};

/** The full name read off a document, if the extraction found one. */
export const fullNameFromFacts = (
  facts: readonly ExtractedFact[],
): string | undefined =>
  nameFact(facts, PERSONAL_DETAILS_TOPIC, FULL_NAME_FACT);

/** The first and last name as the extraction split them, if it did. */
export const namePartsFromFacts = (
  facts: readonly ExtractedFact[],
  topicSlug = PERSONAL_DETAILS_TOPIC,
): NameParts | undefined => {
  const firstName = nameFact(facts, topicSlug, FIRST_NAME_FACT);
  if (!firstName) return undefined;
  return {
    firstName,
    lastName: nameFact(facts, topicSlug, LAST_NAME_FACT) ?? '',
  };
};

/** Whether a name as on their letters is known, so a surname too, not only what they are called. */
export const isFullNameKnown = (facts: readonly ExtractedFact[]) =>
  !!namePartsFromFacts(facts)?.lastName ||
  (fullNameFromFacts(facts)?.split(/\s+/).length ?? 0) > 1;
